//Analytics
export const googleTagManager = {
    gtag_id: 'AW-11371779490',//'GTM-P8Q9VGG';
    enable: true

}

export const searchLocation = {
    apiKeyGoogleMap: "",
    centerMap: { lat: 53.4551528, lng: -1.5152564 },
    zoomInit: 8,
    //markers on the map
    locations: [
        { lat: 53.725754, lng: -1.364864, name: 'Example', address: 'Wellington Street Business Park Castleford WF10 1NW' },

    ],
    //change icon markers
    iconMarket: {
        // url: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'
    },
    //READ -> https://mapstyle.withgoogle.com/
    jsonGooglesStyle: [],
    tittle:"Find a Store Near You",
    placeholder:"Enter your address or Postcode"
}


export const disableSearchWithGoogle = false; // this setting when true disables the right-click on all the site images

export const googleReviewsApiKey = ""; //AIzaSyAsOoN3HsQbahS7AXnqQDb1TjtauAV3YaY